require('./bootstrap-setup');
import AOS from 'aos';
import axios from 'axios';
import Flickity from 'flickity';
import CookieNotification from "bb-cookie-notification";
import {
    gsap
} from "gsap";
import {
    ScrollTrigger
} from 'gsap/ScrollTrigger';
import * as FilePond from "filepond";
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';

gsap.registerPlugin(ScrollTrigger);

AOS.init();

// BenedenBoven cookiescript
new CookieNotification();

// Remove background-img border
document.querySelectorAll('img:not([src])').forEach((element) => {
    element.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
});

// Add and remove class on scroll
if(document.querySelector('nav')) {
    let scrollpos      = window.scrollY
    const header       = document.querySelector("nav")
    const headerHeight = header.offsetHeight

    const addClassOnScroll    = () => header.classList.add("navbar-shrink")
    const removeClassOnScroll = () => header.classList.remove("navbar-shrink")

    window.addEventListener('scroll', function() {
        scrollpos = window.scrollY;

        if(scrollpos >= headerHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }
    });
}

if(document.querySelector('.carousel-info')) {
    const flkty = new Flickity('.carousel-info', {
        cellAlign:       'left',
        contain:         true,
        wrapAround:      true,
        groupCells:      true,
        arrowShape:      '',
        setGallerySize:  false,
        pageDots:        true,
        prevNextButtons: false,
        draggable:       false,
        autoPlay:        5000
    });
}

if(document.querySelector('.carousel-staff')) {
    const flkty2 = new Flickity('.carousel-staff', {
        cellAlign:       'left',
        contain:         true,
        wrapAround:      true,
        groupCells:      true,
        arrowShape:      '',
        setGallerySize:  false,
        pageDots:        true,
        prevNextButtons: false,
        draggable:       true,
        freeScroll:      true,
    });
}

if(document.querySelector('.carousel-cards')) {
    const flkty3 = new Flickity('.carousel-cards', {
        cellAlign:      (window.innerWidth < 768) ? 'left' : 'center',
        wrapAround:     false,
        setGallerySize: false,
        pageDots:       false,
        draggable:      true,
        initialIndex:   1
    });

    const calculateHeight = () => {
        const selected = document.querySelector('.carousel-cards .is-selected');

        const selectedHeight = selected.querySelector('.c-img').getBoundingClientRect().height;

        const height = selectedHeight <= 400 ? 400 : selectedHeight;

        document.querySelector('.carousel-cards .flickity-viewport').style.height = (height + 120) + 'px';
    }

    flkty3.on('select', calculateHeight);

    window.addEventListener('resize', calculateHeight);
    window.addEventListener('load', calculateHeight);
}


// Smooth scroll
if(document.querySelector('.js-scroll-trigger')) {
    document.querySelectorAll('.js-scroll-trigger').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            const href      = event.currentTarget.getAttribute("href");
            const offsetTop = document.querySelector(href).offsetTop;

            scroll({
                top:      offsetTop,
                behavior: "smooth"
            });
        });
    });
}

// Parallax
if(document.querySelector('#parallax')) {
    const elem     = document.querySelector("#parallax");
    const parallax = (e) => {
        let _w                        = window.innerWidth / 2;
        let _h                        = window.innerHeight / 2;
        let _mouseX                   = e.clientX;
        let _mouseY                   = e.clientY;
        let _depth                    = `${50 - (_mouseX - _w) * 0.01}% ${50 - (_mouseY - _h) * 0.01}%`;
        elem.style.backgroundPosition = `${_depth}`;
    }

    document.addEventListener("mousemove", parallax);
}

// Menu
if(document.querySelector('nav')) {

    const nav = document.querySelector('.navbar-toggler');
    nav.addEventListener("click", toggleMenu);
    const navbox = document.querySelector('.nav-content-box');

    function toggleMenu() {
        nav.classList.toggle('open-menu');
        navbox.classList.toggle('show-content-box');
    }

    window.addEventListener('click', function(e) {
        if(!document.querySelector('nav').contains(e.target) && (navbox.classList.contains('show-content-box'))) {
            navbox.classList.remove('show-content-box');
            nav.classList.toggle('open-menu');
        }
    })
}
if(document.querySelector('.special-img')) {
    gsap.to(".special-img", {
        backgroundPosition: "50% 0",
        ease:               "none",
        scrollTrigger:      {
            trigger: ".special-img",
            start:   "top bottom",
            end:     "bottom top",
            scrub:   true
        }
    });
}
if(document.querySelector('.intro-img')) {
    gsap.to(".intro-img", {
        backgroundPosition: "50% 0",
        ease:               "none",
        scrollTrigger:      {
            trigger: ".intro-img",
            start:   "top bottom",
            end:     "bottom top",
            scrub:   true
        }
    });
}
if(document.querySelector('.banner-img')) {
    gsap.to(".banner-img", {
        backgroundPosition: "50% 30%",
        ease:               "none",
        scrollTrigger:      {
            trigger: ".banner-img",
            start:   "top bottom",
            end:     "bottom top",
            scrub:   true
        }
    });
}
if(document.querySelector('header')) {
    gsap.to("header", {
        backgroundPosition: "50% 0",
        ease:               "none",
        scrollTrigger:      {
            trigger: "header",
            start:   "top top",
            end:     "bottom top",
            scrub:   true
        }
    });
}

if(document.querySelector('.specials-home')) {
    document.querySelectorAll('.specials-home [data-image]').forEach((el) => {
        el.addEventListener('mouseover', (e) => {
            document.querySelector('.special-img').style.backgroundImage = 'url("' + e.currentTarget.dataset.image + '")';
            document.querySelector('.special-img .text-white').innerText = e.currentTarget.dataset.title;
        });
    })
}

if(document.querySelector('.cards')) {

    document.querySelectorAll('.card').forEach((element) => {

        element.addEventListener('click', (event) => {
            document.querySelectorAll('.card').forEach(el => el.classList.remove('select-card', 'change-index'));

            event.currentTarget.classList.add('change-index');

            event.currentTarget.classList.add('select-card');
        });
    });

    window.addEventListener('click', (e) => {
        const currentElement = document.querySelector('.card.select-card');
        if(currentElement && !currentElement.contains(e.target)) {
            document.querySelectorAll('.card').forEach(el => el.classList.remove('select-card'));

            setTimeout(function() {
                document.querySelectorAll('.card').forEach(el => el.classList.remove('change-index'));
            }, 500);
        }
    });
}

if(document.querySelector('.files')) {
    FilePond.registerPlugin(FilePondPluginFileValidateType);
    FilePond.registerPlugin(FilePondPluginFileEncode);
    const filepond = FilePond.create(document.querySelector('.files'), {
        allowMultiple:                         true,
        instantUpload:                         false,
        required:                              true,
        acceptedFileTypes:                     ['image/png', 'image/jpeg', 'image/jpg', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
        fileValidateTypeLabelExpectedTypesMap: {
            'image/png':                                                               '.png',
            'image/jpeg':                                                              '.jpg',
            'image/jpg':                                                               '.jpg',
            'application/pdf':                                                         '.pdf',
            'application/msword':                                                      '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx'
        },
        labelFileTypeNotAllowed:               'Onjuist bestandstype!',
        fileValidateTypeLabelExpectedTypes:    'Alleen {allButLastType} en {lastType} zijn togestaan',
        labelIdle:                             'Sleep je cv/motivatie hiernaartoe of <span class="filepond--label-action"> blader </span>'
    });
}

const submitForm = (gRecaptchaResponse) => {
    const form = document.querySelector('.form');

    const submitButton = form.querySelector('[type="submit"]');
    submitButton.classList.add('disabled');
    submitButton.disabled  = true;
    submitButton.innerHTML = '<div class="spinner-border spinner-border-sm" role="status"><span class="visually-hidden">Laden...</span></div>';

    const formData = new FormData(form);
    formData.append('g-recaptcha-response', gRecaptchaResponse);

    const validationAlert = document.getElementById('form-validation');
    validationAlert.classList.add('d-none');
    validationAlert.classList.remove('alert-danger');

    document.querySelectorAll('.invalid-feedback').forEach((element) => {
        if(!element.classList.contains('d-none')) {
            element.classList.add('d-none');
        }
    });

    document.querySelectorAll('.is-invalid').forEach((element) => {
        element.classList.remove('is-invalid');
    });

    axios.post(form.action, formData).then((response) => {
        if(response.data.success) {
            validationAlert.innerHTML = response.data.message;
            validationAlert.classList.add('alert-success');
            validationAlert.classList.remove('d-none');

            form.innerHTML = '';
        }
    }).catch((exception) => {
        if(exception.response.data.errors) {
            for(let error in exception.response.data.errors) {
                const el = form.querySelector('[id="' + error + '"]');
                el.classList.add('is-invalid');
                if(el.parentNode.querySelector('.d-none') !== null) {
                    el.parentNode.querySelector('.d-none').classList.remove('d-none');
                }
            }
        }
    }).finally(() => {
        submitButton.classList.remove('disabled');
        submitButton.disabled  = false;
        submitButton.innerHTML = 'Verstuur bericht';
    });
}

window.submitForm = submitForm;

if(window.location.hash) {
    setTimeout(() => {
        const hash = window.location.hash;
        if(document.querySelector(hash)) {
            const y = document.querySelector(hash).parentNode.getBoundingClientRect().top + window.scrollY - 150;

            if(document.querySelector(hash + '-tab')) {
                document.querySelector(hash + '-tab').click();
            }

            scroll({
                top:      y,
                behavior: "smooth"
            });
        }
    }, 400);
}